<template>
  <div class="home">
    <my-header activeNum="7" :panoNum="type" userNum="1"></my-header>
    <div class="main">
      <div class="page">
        <div class="page-left">
          <div class="add-line">
            <el-button type="primary" @click="dialog=true">从素材库添加</el-button>
            <span style="margin-left: 20px;">还没有将素材上传至素材库？</span>
            <a class href="../my/media">去上传</a>
          </div>
          <div class="list-block" v-if="type=='1'">
            <div class="empty" v-if="arr.length==0">
              <div class="EmptyList__Tip-jAXaGo jCnrcq">请先“从素材库添加”素材</div>
              <p>支持 2:1全景图片素材</p>
              <p>2:1 最大支持120MB以内的全景图片</p>
              <!-- <p>
                基础版&amp;单作品升级可展示全高清六面体，专业版可展示超高清碎片图
              </p>-->
            </div>
            <div class="list" v-else>
              <div class="list-li" v-for="(item,i) in arr" :key="i">
                <div class="li-img">
                  <img :src="item.thumbnailUrl" />
                </div>
                <div class="li-right">
                  <div class="li-title">{{item.fileName}}</div>
                  <div class="li-btns">
                    <!-- <a class="li-btn">预览</a> -->
                    <a class="li-btn" @click="del(i)">移除</a>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="list-block" v-if="type=='2'">
            <div class="empty" v-if="arr.length==0">
              <div class="EmptyList__Tip-jAXaGo jCnrcq">请先“从素材库添加”素材</div>
              <p>全景视频素材最大支持：3GB</p>
              <p>最小分辨率: 1280x640 视频格式: mp4 编码: H.264 宽高比例为2:1</p>
              <!-- <p>
                基础版&amp;单作品升级可展示全高清六面体，专业版可展示超高清碎片图
              </p>-->
            </div>
            <div class="list" v-else>
              <div class="list-li" v-for="(item,i) in arr" :key="i">
                <div class="li-img">
                  <img :src="item.thumbnailUrl" />
                </div>
                <div class="li-right">
                  <div class="li-title">{{item.fileName}}</div>
                  <div class="li-btns">
                    <!-- <a class="li-btn">预览</a> -->
                    <a class="li-btn" @click="del(i)">移除</a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="page-right">
          <el-button
            type="primary"
            :disabled="arr.length==0? true:false"
            class="submit"
            @click="submit"
          >发布作品</el-button>
          <div class="group">
            <div required class="group-title">
              <span>作品标题</span>
            </div>
            <el-input v-model="title" placeholder="请输入作品标题"></el-input>
          </div>
          <div class="group">
            <div required class="group-title">
              <span>作品分类</span>
            </div>
            <el-select v-model="optionsValue" placeholder="请选择">
              <el-option
                v-for="item in options"
                :key="item.id"
                :label="item.labelName"
                :value="item.id"
              ></el-option>
            </el-select>
          </div>
        </div>
      </div>
    </div>

    <my-database v-if="dialog" :type="type" :closeFunc="close" :submitFunc="add"></my-database>
    <!-- <my-picture v-if="dialogPic" :closeFunc="closePic" :data="data"></my-picture> -->
    <my-footer></my-footer>
  </div>
</template>
<style scoped>
img {
  height: 100%;
  width: 100%;
}
.home {
  min-width: 1180px;
  background-color: #f8f8f8;
}
.main {
  position: relative;
  margin: 20px auto;
  width: 1180px;
  min-height: calc(100vh - 130px);
  background-color: rgb(255, 255, 255);
}
.page {
  display: flex;
  position: absolute;
  top: 0px;
  right: 0px;
  bottom: 0px;
  left: 0px;
}

.page-left {
  display: flex;
  flex-flow: column;
  position: relative;
  flex: 1 1 0%;
  padding: 20px;
}

.page-right {
  position: relative;
  flex: 0 0 320px;
  border-left: 1px solid rgb(239, 239, 239);
  padding: 20px;
}

.add-line {
  width: 100%;
  display: flex;
  align-items: center;
  padding-bottom: 20px;
  border-bottom: 1px solid rgb(239, 239, 239);
}

.list-block {
  position: relative;
  flex: 1 1 0%;
}
.list {
  margin-left: -20px;
  padding: 20px 5px;
}
.list-li {
  display: inline-flex;
  align-items: center;
  width: 250px;
  height: 90px;
  background-color: rgb(248, 248, 248);
  margin-bottom: 20px;
  margin-left: 20px;
  padding: 0px 20px;
}

.li-img {
  width: 50px;
  height: 50px;
  margin-right: 10px;
}

.li-right {
  display: flex;
  justify-content: space-between;
  flex-flow: column;
}

.li-title {
  display: inline-block;
  max-width: 150px;
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow-wrap: normal;
  margin-bottom: 12px;
  overflow: hidden;
}

.li-btn {
  margin-right: 20px;
  color: rgb(66, 122, 251);
  cursor: pointer;
}

.empty {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-flow: column;
  position: absolute;
  top: 0px;
  right: 0px;
  bottom: 0px;
  left: 0px;
  line-height: 1.4286;
}

.submit {
  width: 100%;
  margin-bottom: 20px;
}

.group {
  margin-bottom: 20px;
}

.group-title {
  margin-bottom: 20px;
}

.group-title span::after {
  content: "*";
  margin-left: 5px;
  color: rgb(243, 98, 100);
}

.el-select {
  width: 100%;
}
</style>
<script>
import https from '../https.js'
import MyHeader from '../components/header.vue'
import MyFooter from '../components/footer.vue'
import MyDatabase from '../components/database.vue'
import MyPicture from '../components/picture.vue'
export default {
  name: '',
  components: {
    MyHeader: MyHeader,
    MyFooter: MyFooter,
    MyDatabase: MyDatabase,
    MyPicture: MyPicture
  },
  data() {
    return {
      type: '1',
      title: '',
      optionsValue: '',
      options: [
        {
          label: '风光',
          value: '1'
        }
      ],
      dialog: false,
      arr: [
        // {
        //   id: "44901c67-81c4-4f30-8fea-c1d0dfc1927b",
        //   fileName: "weixin_code.png",
        //   filePath: "/Attached/2020/6/17/weixin_code.png",
        //   fileFormat: ".png",
        //   hashValue: "2020617135921",
        //   fileSize: 11917,
        //   type: null,
        //   status: 1,
        //   createTime: "2020-06-17T13:59:21.487",
        //   thumbnailUrl: null
        // }
      ],

      dialogPic: true,
      data: {
        hotPoint: {
          createTime: '2020-07-03T14:26:02.713',
          hotContext: 'https://www.baidu.com',
          hotPointURL: '12',
          hotTitle: '金枝玉叶',
          hotType: 4,
          id: 'd12784a5-68ac-4287-aea1-6f74cb862f5f',
          physicalFile_Scene_ID: '70edd198-b00b-4e6e-9fef-c59b150a7cd5',
          posX: -1764.49,
          posY: -163.68,
          posZ: -927.24,
          status: 1
        },
        physicalFilelist: [
          {
            createTime: '2020-07-03T13:48:01.03',
            fileFormat: '.jpg',
            fileName: 'c01.jpg',
            filePath: '/imgs/points/gif1.png',
            fileSize: 1112754,
            hashValue: '8a55f49b6ba4bfe095949845577cdd7c',
            id: '251e28fe-f6a3-45d8-891f-57e2e6cf4e05',
            status: 1,
            thumbnailUrl:
              '/Attached/2020/7/3/8a55f49b6ba4bfe095949845577cdd7c_Thumbnail.jpg',
            type: 1
          },
          {
            createTime: '2020-07-03T13:48:01.03',
            fileFormat: '.jpg',
            fileName: 'c02.jpg',
            filePath: '/Attached/2020/7/3/8a55f49b6ba4bfe095949845577cdd7c',
            fileSize: 1112754,
            hashValue: '8a55f49b6ba4bfe095949845577cdd7c',
            id: '251e28fe-f6a3-45d8-891f-57e2e6cf4e051',
            status: 1,
            thumbnailUrl:
              '/Attached/2020/7/3/8a55f49b6ba4bfe095949845577cdd7c_Thumbnail.jpg',
            type: 1
          }
        ]
      }
    }
  },
  watch: {
    $route(to, from) {
      this.type = to.query.type
      this.$router.go(0)
    }
  },
  created() {},
  mounted() {
    const t = this.$route.query.type || 1
    this.type = t
    this.initLabel()
  },
  methods: {
    closePic() {
      this.dialogPic = false
    },
    initLabel() {
      https.fetchGet('/api/Label/Get', {}).then(res => {
        this.options = res.data
      })
    },
    close() {
      this.dialog = false
    },
    add(item) {
      const addArr = this.arr.slice()
      for (let i = 0; i < item.length; i++) {
        let isSame = false
        for (let j = 0; j < this.arr.length; j++) {
          if (item[i].id == this.arr[j].id) {
            isSame = true
            break
          }
        }
        if (!isSame) {
          addArr.push(item[i])
        }
      }
      this.arr = addArr
    },
    del(num) {
      this.arr.splice(num, 1)
    },
    submit() {
      console.log(1)
      const upArr = []
      for (let i = 0; i < this.arr.length; i++) {
        upArr.push({
          physicalFileID: this.arr[i].id
        })
      }
      if (this.title == '') {
        this.$message({
          showClose: true,
          type: 'error',
          message: '作品标题不能为空!'
        })
      } else if (this.optionsValue == '') {
        this.$message({
          showClose: true,
          type: 'error',
          message: '作品分类不能为空!'
        })
      } else {
        https
          .fetchPost('/api/Scene/Add', {
            type: this.type,
            sceneName: this.title,
            labelID: this.optionsValue
          })
          .then(res => {
            console.log(res.data)
            const sceneID = res.data.id || ''
            if (sceneID != '') {
              https
                .fetchPost('/api/Scene/PhysicalFileID_SceneID', {
                  sceneID: sceneID,
                  physicalFile_Scene: upArr
                })
                .then(res => {
                  console.log(res.data)
                  this.$router.push('../my/product?type=' + this.type)
                })
            }
          })
      }
    }
  }
}
</script>
